import API from "./API";

// user login api
export const userLogin = async (fromData) => {
  const response = await API.post(`api/login/`, fromData, {
    headers: { "Content-Type": "application/json" },
  }).catch();
  return response ? response.data : {};
};
// staff creation
export const staffCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/users/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const staffList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/users/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const deleteStaff = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/users/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const updateStaff = async (staff_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/users/${staff_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
//branch crud

export const branchCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/branches/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const branchList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/branches/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const deleteBranch = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/branches/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const updateBranch = async (branch_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/branches/${branch_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
//party crud

export const partyCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/parties/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const partyList = async (params = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/parties/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params,
  }).catch();
  return response ? response.data : {};
};

export const deleteParty = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/parties/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const updateParty = async (party_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/parties/${party_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// party and branch list
export const branchpartyList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/party-branch-list/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

//freight crud

export const freightCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.post(`api/freights/`, fromData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });
    if (!response || !response.data) {
      return {};
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const freightList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };

  try {
    const response = await API.get(`api/freights/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        party_name: filters.party_name || "",
        lr_number: filters.lr_number || "",
        do_no: filters.do_no || "",
        ref_no: filters.ref_no || "",
        truck_no: filters.truck_no || "",
        loading_date: formatDate(filters.loading_date),
        from_to: filters.from_to || "",
        freight_not_rec: filters.freight_not_rec || false,
        date_filter: filters.date_filter || "",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Failed to fetch freight list:", error);
    return { results: [], next: null };
  }
};

export const freightDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));

  try {
    const response = await API.delete(`api/freights/${id}`, {
      headers: {
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("DELETE error:", error.response?.data);
    return error.response?.data || {};
  }
};


export const updateFreight = async (freight_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/freights/${freight_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const freightComplete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/freights/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
// due freight page crud

export const freightListforInvoiceCreation = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(
    `api/freights/invoice/creation/?page=${page}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        party_name: filters.party_name || "",
        do_no: filters.do_no || "",
        truck_no: filters.truck_no || "",
      },
    },
  ).catch(() => {});
  return response ? response.data : {};
};

export const dueFreightDelete = async (freight_id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(
    `api/freights/invoice/creation/${freight_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch();
  return response ? response.data : {};
};
export const dueFreightUpdate = async (freight_id, formdata) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(
    `api/freights/invoice/creation/${freight_id}`,
    formdata,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch();
  return response ? response.data : {};
};

export const getFreightsByPartyIdApi = async (party_id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/party/freights/${party_id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

//issue crud
export const issueCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/issues/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const issueList = async (params = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const query = new URLSearchParams();
  if (params.truck_no?.trim()) query.append("truck_no", params.truck_no.trim());
  if (params.party_name?.trim())
    query.append("party_name", params.party_name.trim());
  if (params.truck_owner?.trim())
    query.append("truck_owner", params.truck_owner.trim());

  const queryString = query.toString();
  const url = `api/issues/${queryString ? `?${queryString}` : ""}`;

  const response = await API.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();

  return response ? response.data : {};
};

export const issueSolveapi = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/issues/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const issueListbyVehilce = async (vehicle_id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/freight/issues/${vehicle_id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// dropdown crud

//history crud
export const todayHistoryList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/history/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
//bill crud
export const getFreightsByBilPartyIdApi = async (party_id, party_type = "consignor") => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/party/freights/bill/${party_id}`, {
    params: { party_type },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
// freight invoice crud
export const freightInvoiceCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/freight/invoice/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const freightInvoiceList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/freight/invoice/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
//freight pay crud

export const freightPayCreate = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/freight-payments/${id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const freightPayList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const params = { page };

  params.lr_number = filters.lr_number;
  params.pay_date = filters.pay_date;

  const response = await API.get(`api/freight-payments/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params,
  }).catch();
  return response ? response.data : {};
};

export const freightPayListReports = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("api/all/freights/payment/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        lr_number: filters.lrNumber || "",
        created_at: filters.created_at || "",
      },
    });
    return response.data; // Expecting { count, next, previous, results }
  } catch (error) {
    console.error("Error fetching billings:", error);
    return {};
  }
};

export const paySettlement = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/freight-payments/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const freightPayDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/freight-payments/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const freightPayUpdate = async (freight_pay_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(
    `api/freight-payments/${freight_pay_id}`,
    fromData,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch();
  return response ? response.data : {};
};

//freight pay crud

export const billCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/billings/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const billList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`api/billings/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        billDate: filters.billDate || "",
        lrNumber: filters.lrNumber || "",
        party: filters.party || "",
      },
    });
    return response.data; // expect { results: [], next: ... } structure
  } catch (error) {
    console.error("Error fetching bills:", error);
    return { results: [], next: null };
  }
};

export const billSettlement = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/billings/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const billDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/billings/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const billUpdate = async (bill_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/billings/${bill_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const billFreightList = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/bill/freight/list/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// get bill by party id
export const getBillsByPartyApi = async (party_id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/payments/${party_id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// party payment crud
export const paymentList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/payments/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const paymentsCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/payments/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// party payment crud
export const dashboardApi = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/dashboard/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// truck freight
export const truckfreightList = async (truck_no) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/truck/freight/${truck_no}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// 1. All Freights

export const allfreightList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split("T")[0]; // sirf YYYY-MM-DD return karega
  };
  try {
    const response = await API.get("freights/all/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        party_name: filters.party_name || "",
        truck_no: filters.truck_no || "",
        loading_date: formatDate(filters.loading_date),
        lr_number: filters.lr_number || "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch freight list", error);
    return { results: [], next: null };
  }
};

// 2. Bill Pending Freights
export const billPendingFreights = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  // Remove undefined/null/empty values
  const cleanFilters = {};
  Object.keys(filters).forEach((key) => {
    if (
      filters[key] !== undefined &&
      filters[key] !== null &&
      filters[key] !== ""
    ) {
      cleanFilters[key] = filters[key];
    }
  });

  const params = new URLSearchParams({ page, ...cleanFilters });

  const response = await API.get(
    `freights/bill-pending/?${params.toString()}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch(() => null);

  return response ? response.data : { results: [], next: null };
};

// 3. Completed Freights

export const completedFreights = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`freights/completed/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        party_name: filters.party_name || "",
        lr_number: filters.lr_number || "",
        truck_no: filters.truck_no || "",
      },
    });
    return response.data;
  } catch (error) {
    return { results: [], next: null };
  }
};

// 4. Freights by Party ID

export const freightsByParty = async (party_id, page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`freights/party/${party_id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      lr_number: filters.lr_number || "",
      truck_no: filters.truck_no || "",
    },
  }).catch(() => null);

  return response ? response.data : { results: [], next: null };
};
// 5. Freights by Branch ID

export const freightsByBranch = async (branch_id, page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`freights/branch/${branch_id}/?page=${page}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      tp_no: filters.tp_no || "",
      truck_no: filters.truck_no || "",
    },
  }).catch(() => null);
  return response ? response.data : { results: [], next: null };
};

// 6. Unique Truck Numbers
export const uniqueTruckNumbers = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`freights/truck-numbers/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => {});
  return response ? response.data : {};
};

// 7. Freights by Truck Number

export const freightsByTruck = async (truck_no, page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`freights/truck/${truck_no}/?page=${page}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        ...(filters.lr_number && { lr_number: filters.lr_number }),
        ...(filters.party_name && { party_name: filters.party_name }), // ← was missing
      },
    });

    if (!response?.data) return { results: [], next: null, count: 0 };

    if (Array.isArray(response.data.results)) {
      return {
        results: response.data.results,
        next: response.data.next || null,
        previous: response.data.previous || null,
        count: response.data.count || 0,
      };
    }

    if (Array.isArray(response.data)) {
      return {
        results: response.data,
        next: null,
        previous: null,
        count: response.data.length,
      };
    }

    return { results: [], next: null, count: 0 };
  } catch (error) {
    console.error("Error fetching freightsByTruck:", error);
    return { results: [], next: null, count: 0 };
  }
};

//1. all bills

export const getAllBillings = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("billing-report/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        payDate: filters.payDate || "",
        lrNumber:filters.lrNumber ||"",
        party: filters.party || "",
      },
    });
    return response.data; // Expecting { count, next, previous, results }
  } catch (error) {
    console.error("Error fetching billings:", error);
    return {};
  }
};

// 2. complete bills

export const getCompleteBillings = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("billing-report/complete/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        payDate: filters.payDate || "",
        lrNumber: filters.lrNumber || "",
        party: filters.party || "",
      },
    });
    return response.data; // Expecting { count, next, previous, results }
  } catch (error) {
    console.error("Error fetching billings:", error);
    return {};
  }
};

// 3. pending bills

export const getPendingBillings = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("billing-report/pending/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        payDate: filters.payDate || "",
        lrNumber: filters.lrNumber || "",
        party: filters.party || "",
      },
    });
    return response.data; // Expecting { count, next, previous, results }
  } catch (error) {
    console.error("Error fetching billings:", error);
    return {};
  }
};

// 4. party bills

export const getBillingsByParty = async (partyId, page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`billing-report/party/${partyId}/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        lrNumber: filters.lrNumber || "",
        billDate: filters.billDate || "",
      },
    });
    return response.data; // Expecting { count, next, previous, results }
  } catch (error) {
    console.error("Error fetching billings:", error);
    return {};
  }
};

// 5. branch bills

export const getBillingsByBranch = async (branchId) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`billing-report/branch/${branchId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => {});
  return response ? response.data : {};
};

//    recycle bin

export const staffRestore = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/staff/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const staffRecycle = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/staff/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const branchRestore = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/branch/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const branchRecycle = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/branch/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const partyRestore = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/party/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const partyRecycle = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/party/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const freightRestore = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/freight/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const freightRecycle = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/freight/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const billRestore = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/bill/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const billRecycle = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/bill/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const freightPrint = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/freight/print/?freight_id=${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const paymentPrint = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(
    `api/payment/print/?freight_payment_id=${id}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch();
  return response ? response.data : {};
};

// Fetch Freight data with optional date filter
export const fetchFreightFilter = async (startDate = "", endDate = "") => {
  const access = JSON.parse(localStorage.getItem("access"));
  let url = "api/freight-date-filter/"; // ✅ updated endpoint

  if (startDate && endDate) {
    url += `?start_date=${startDate}&end_date=${endDate}`;
  }

  const response = await API.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Error fetching freights:", err);
  });

  return response ? response.data : [];
};

// ==================== VEHICLE CRUD ====================

// Create Vehicle
export const vehicleCreate = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/vehicles/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch((error) => {
    console.error("Vehicle create error:", error);
    return error.response;
  });
  return response ? response.data : {};
};

// Get Vehicle List
export const vehicleList = async (search = "", status = "", page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));
  let url = `api/vehicles/?page=${page}`;
  if (search) url += `&search=${search}`;
  if (status) url += `&status=${status}`;

  const response = await API.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Get Single Vehicle
export const getVehicleDetails = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/vehicles/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Update Vehicle
export const updateVehicle = async (vehicle_id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/vehicles/${vehicle_id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Delete Vehicle
export const deleteVehicle = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/vehicles/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Upload Vehicle Documents
export const uploadVehicleDocuments = async (vehicle_id, files) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const formData = new FormData();

  Object.keys(files).forEach((key) => {
    if (files[key]) {
      formData.append(key, files[key]);
    }
  });

  const response = await API.post(
    `api/vehicles/documents/${vehicle_id}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch();
  return response ? response.data : {};
};

// Delete Vehicle Document
export const deleteVehicleDocument = async (vehicle_id, document_type) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/vehicles/documents/${vehicle_id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    data: { document_type },
  }).catch();
  return response ? response.data : {};
};

// Get Dashboard Stats
export const getVehicleDashboardStats = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/vehicles/dashboard/stats/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Get Expiring Vehicles
export const getExpiringVehicles = async (page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/vehicles/expiring/?page=${page}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Restore Vehicle from Recycle Bin
export const restoreVehicle = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/vehicle/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Get Deleted Vehicles List
export const getDeletedVehicles = async (search = "", page = 1) => {
  const access = JSON.parse(localStorage.getItem("access"));
  let url = `api/recycle-bin/vehicle/?page=${page}`;
  if (search) url += `&search=${search}`;

  const response = await API.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// ==================== LR NUMBER GENERATE ====================

// Generate LR Number (Form submit se pehle)
export const generateLRNumber = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/generate-lr-number/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((error) => {
    console.error("Failed to generate LR number:", error);
    return error.response;
  });
  return response ? response.data : {};
};

// ==================== VEHICLE EXPENSE ====================

// Get Expense List
export const getExpenseList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  let url = `api/expenses/?page=${page}`;
  if (filters.search) url += `&search=${filters.search}`;
  if (filters.expense_type && filters.expense_type !== "all")
    url += `&expense_type=${filters.expense_type}`;
  if (filters.vehicle_number && filters.vehicle_number !== "all")
    url += `&vehicle_number=${filters.vehicle_number}`;

  const response = await API.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Create Expense
export const createExpense = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/expenses/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Get Expense Details
export const getExpenseDetails = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/expenses/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Update Expense
export const updateExpense = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/expenses/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Delete Expense
export const deleteExpense = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/expenses/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Get Expense Summary by Vehicle
export const getExpenseSummary = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/expenses-summary/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// Get document alerts summary (expiring + expired documents)
export const getDocumentAlertsSummary = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`api/vehicles/document-alerts-summary/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching document alerts summary:", error);
    // Return empty structure on error
    return {
      expiring: [],
      expired: [],
      stats: {
        total_expiring: 0,
        total_expired: 0,
        critical_count: 0,
      },
    };
  }
};

//  CUSTOMER API SERVICES

export const getCustomers = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get("api/customers/", {
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : [];
};

export const getCustomerById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/customers/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const createCustomer = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post("api/customers/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : null;
};

export const updateCustomer = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/customers/${id}/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : null;
};

export const patchCustomer = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.patch(`api/customers/${id}/`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : null;
};

export const deleteCustomer = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/customers/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : null;
};

//  TESTIMONIAL API SERVICES

export const getTestimonials = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get("api/testimonials/", {
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : [];
};

export const getTestimonialById = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/testimonials/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const createTestimonial = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post("api/testimonials/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : null;
};

export const updateTestimonial = async (id, formData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/testimonials/${id}/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : null;
};

export const patchTestimonial = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.patch(`api/testimonials/${id}/`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : null;
};

export const deleteTestimonial = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/testimonials/${id}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : null;
};

export const submitContactEnquiry = async (data) => {
  const response = await API.post("api/contact/", data, {
    headers: {
      "Content-Type": "application/json",
    },
  }).catch(() => null);
  return response ? response.data : null;
};

export const getAllEnquiries = async (params = {}) => {
  const response = await API.get("api/contact/", { params }).catch(() => null);
  return response ? response.data : null;
};

export const getEnquiryById = async (id) => {
  const response = await API.get(`api/contact/${id}/`).catch(() => null);
  return response ? response.data : null;
};

export const markEnquiryAsRead = async (id) => {
  const response = await API.patch(`api/contact/${id}/`, {
    is_read: true,
  }).catch(() => null);
  return response ? response.data : null;
};

export const deleteEnquiry = async (id) => {
  const response = await API.delete(`api/contact/${id}/`).catch(() => null);
  return response ? response.data : null;
};

export const expiringEwayBills = async (filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`api/expiring-eway-lr/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        include_expired: filters.include_expired ?? true,
        party_name: filters.party_name || "",
        truck_no: filters.truck_no || "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch expiring e-way bills:", error);
    return { results: [], next: null };
  }
};

// ─── RBAC — User Page Permissions ────────────────────────────────────────────

export const getUserPermissions = async (userId) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/user-permissions/${userId}/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : { allowed_pages: [] };
};

export const setUserPermissions = async (userId, allowedPages) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(
    `api/user-permissions/${userId}/`,
    { allowed_pages: allowedPages },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    },
  ).catch();
  return response ? response.data : {};
};


export const customBillCreate = async (data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.post("api/billing/custom/", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Custom bill create error:", error.response?.data || error.message);
    throw error;
  }
};

export const customBillUpdate = async (id, data) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.put(`api/billing/custom/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Custom bill update error:", error.response?.data || error.message);
    throw error;
  }
};

export const customBillList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("api/billing/custom/", {
      params: { page, ...filters },
      headers: {
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Custom bill list error:", error.response?.data || error.message);
    return { results: [], next: null };
  }
};

export const customBillDetail = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`api/billing/custom/${id}`, {
      headers: {
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Custom bill detail error:", error.response?.data || error.message);
    return null;
  }
};

export const customBillDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.delete(`api/billing/custom/${id}`, {
      headers: {
        Authorization: `Bearer ${access}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Custom bill delete error:", error.response?.data || error.message);
    throw error;
  }
};


export const markLRAsBlank = async (lrNumbers, reason = "") => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(
    `api/mark-lr-blank/`,
    {
      lr_numbers: lrNumbers,
      reason: reason,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    }
  ).catch((error) => {
    console.error("Failed to mark LR as blank:", error);
    return error.response;
  });
  return response ? response.data : {};
};

export const blankLRList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/blank-lr-list/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((error) => {
    console.error("Failed to fetch blank LR list:", error);
    return error.response;
  });
  return response ? response.data : {};
};


export const restoreBlankLR = async (lrNumber) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(
    `api/restore-blank-lr/`,
    { lr_number: lrNumber },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    }
  ).catch((error) => {
    console.error("Failed to restore LR:", error);
    return error.response;
  });
  return response ? response.data : {};
};

export const getExpenseReport = async (params = {}) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    const queryString = new URLSearchParams();
    if (params.vehicle_number) queryString.append("vehicle_number", params.vehicle_number);
    if (params.from_date) queryString.append("from_date", params.from_date);
    if (params.to_date) queryString.append("to_date", params.to_date);

    const url = `api/expense-report/${queryString.toString() ? `?${queryString}` : ""}`;
    const response = await API.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    }); 
    return response.data ?? response;
  } catch (error) {
    console.error("Error fetching expense report API:", error);
    throw error;
  }
};

export const exportExpenseReportExcel = async (params = {}) => {
  try {
    const access = JSON.parse(localStorage.getItem("access"));
    const queryString = new URLSearchParams();
    if (params.vehicle_number && params.vehicle_number !== "all")
      queryString.append("vehicle_number", params.vehicle_number);
    if (params.from_date) queryString.append("from_date", params.from_date);
    if (params.to_date) queryString.append("to_date", params.to_date);

    const url = `api/expense-report/export-excel/${
      queryString.toString() ? `?${queryString}` : ""
    }`;

    const response = await API.get(url, {
      headers: {
        Authorization: `Bearer ${access}`,
      },
      responseType: "blob", // 
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    const objectUrl = window.URL.createObjectURL(blob);

    let filename = "Expense_Report.xlsx";
    const disposition = response.headers?.["content-disposition"];
    if (disposition) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) filename = match[1];
    }

    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectUrl);

    return true;
  } catch (error) {
    console.error("Error exporting expense excel:", error);
    throw error;
  }
};